import moment from 'moment';
import React, { useEffect, useRef, useState } from 'react';
import { View, ScrollView, FlatList, ActivityIndicator } from 'react-native';
import { useDispatch, useSelector } from 'react-redux';
import Colors from '../../constants/Colorsv2';
import { Text } from '../../globalComponents/NativeOverrides';
import { event_getEventByEventId, event_getMatchByMatchId, event_getTournamentByTournamentId } from '../../store/actionsv1/events';
import { market_getOrderByOrderId } from '../../store/actionsv1/markets';
import { OrderActivityProps, OrderProps } from '../../store/types/mk_svc';
import { EventProps, MatchProps, TournamentProps } from '../../store/types/sr_svc';
import EventInfoCard from './components/EventInfoCard';
import MatchInfoCard from './components/MatchInfoCard';
import TournamentInfoCard from './components/TournamentInfoCard';
import { market_getOddsLabel } from './helpers/markets';
import { order_getOrderActivities } from './helpers/orders';


const TimelineBubble = ({ active_ind, step }:{ active_ind:boolean, step:number }) => {
    return (
        <View style={{ justifyContent:'center', alignItems:'center', borderRadius:100, height:40, width:40, borderWidth:1, borderColor:Colors.brand.cyan, backgroundColor:active_ind?Colors.brand.cyan:'transparent' }}>
            <Text size={16} weight='bold' color={Colors.shades.white}>{step}</Text>
        </View>
    )
}


const OrderActivityScreen = ({navigation, route}:any) => {
    const [ loading, setLoading ] = useState(false)

    const scroll_ref = useRef();
    const dispatch = useDispatch();
    const app_size:any = useSelector((state:any) => state.util.app_size, (left, right) => left?.width === right?.width)
    const order:OrderProps | undefined = useSelector((state:any) => state.player.orders.orders.find((o:OrderProps) => o.order_id == route.params?.order_id), (left, right) => left?.order_id == right?.order_id)
    const event = useSelector((state:any) => state.event.events[order?.event_id??''], (left, right) => {
        if(left?.time_detail != right?.time_detail){ return false }
        return true
    })
    const tournament = useSelector((state:any) => state.event.tournaments[order?.event_id??''], (left, right) => left?.tournament_id == right?.tournament_id)
    const match = useSelector((state:any) => state.event.matches[order?.event_id??''], (left, right) => left?.time_detail == right?.time_detail)
    const leagues = useSelector((state:any) => state.event.leagues, (left, right) => left.length === right.length)

    useEffect(() => {
        if(!route.params?.order_id){ return }
        getOrderFromServer(route.params.order_id)
    },[route.params?.order_id])

    useEffect(() => {
        if(!order){ return }
        getEventDetailsFromServer(order.event_id, order.event_type)
    },[order])

    const getOrderFromServer = async(order_id:string) => {
        setLoading(true)
        await dispatch(market_getOrderByOrderId(order_id))
        setLoading(false)
    }

    const getEventDetailsFromServer = async(event_id:string, event_type:string) => {
        if(event_type === 'team' && !event){ dispatch(await event_getEventByEventId(event_id)) }
        if(event_type === 'tournament' && !tournament){ dispatch(await event_getTournamentByTournamentId(event_id)) }
        if(event_type === 'match' && !match){ dispatch(await event_getMatchByMatchId(event_id)) }
    }

    const order_activities = order_getOrderActivities(order)


    const renderActivity = (data: { item:OrderActivityProps, index:number }) => {
        const l = data.index === order_activities.length-1?true:false //If true, we are on the last one
        return (
            <View style={{flex:1, flexDirection:'row'}}>                    
                <View style={{flex:1.5/7, justifyContent:'center', alignItems:'center'}}>
                    <TimelineBubble step={data.index+1} active_ind={l}/>
                    <View style={{flexDirection:'row'}}>
                        <View style={{flex:1/2, borderRightWidth:l?0:1, borderColor:Colors.brand.cyan, height:40}} />
                        <View style={{flex:1/2}} />
                    </View>

                </View>
                <View style={{flex:5.5/7, paddingLeft:10, justifyContent:'flex-start', alignItems:'flex-start'}}>
                    <Text size={14} weight='semibold' color={Colors.shades.white}>{data.item.activity_description}</Text>
                    <Text size={12} weight='regular' color={Colors.accents.accent200}>{moment(data.item.activity_datetime).format('YYYY-MM-DD hh:mm a')}</Text>
                </View>
            </View>
        )
    }



    if(loading || !order){
        return (
            <View style={{ justifyContent:'center', alignItems:'center', backgroundColor:Colors.shades.white, padding:20 }}>
                <ActivityIndicator size='large' color={Colors.brand.midnight} />
            </View>
        )
    }

    return (
        <View style={{ flex:1,  backgroundColor:Colors.shades.white }}>
            <ScrollView style={{ flex:1 }}>
            <View nativeID='activity-header'>
                    {order.event_type === 'team' && event ?
                    <EventInfoCard event={event} league={leagues.find(l => l.league_id == event.league_id)}/>
                    :<></>}
                    {order.event_type === 'tournament' && tournament ?
                    <TournamentInfoCard tournament={tournament} league={leagues.find(l => l.league_id == tournament.league_id)}/>
                    :<></>}
                    {order.event_type === 'match' && match ?
                    <MatchInfoCard match={match} league={undefined} tournament={undefined}/>
                    :<></>}
            </View>
            <View style={{ minHeight: app_size.height, marginTop:30, backgroundColor:Colors.brand.midnight, padding:30, borderTopRightRadius:27, borderTopLeftRadius:27}}>
                <View style={{justifyContent:'center', alignItems:'center'}}>
                    <Text textAlign='center' size={16} weight='bold' color={Colors.shades.white} style={{marginBottom:2}}>{order.title}</Text>
                    <Text textAlign='center' size={16} weight='regular' color={Colors.shades.white}>{(order.probability*100).toFixed(2)}% ({market_getOddsLabel(order.odds)})</Text>
                </View>
                <View style={{marginTop:30}}>
                    <FlatList 
                    ref={scroll_ref}
                    onContentSizeChange={(contentWidth, contentHeight)=>{        
                        scroll_ref?.current?.scrollToEnd({animated: true});
                    }}
                    data={order_activities} renderItem={renderActivity} keyExtractor={(item, index) => index.toString()} />
                </View>
            </View>
            </ScrollView>
        </View>
    )
}

export default OrderActivityScreen